export default "__VITE_ASSET__JTrcOvvW__"